import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import API_ROUTES from "../hooks/apiRoutes";

/**
 * TELA DE LOGIN DA TV (pareamento) — rota /tv/entrar.
 *
 * Mostra um código grande e fica perguntando ao backend (poll) se já vincularam. Quando a
 * pessoa digita o código no celular (rota /tv), o poll recebe o token, salva e entra. Nada
 * de digitar email/senha no controle. Ver DeviceAuthController no backend.
 */
export default function TvPairing() {
  const navigate = useNavigate();
  const [code, setCode] = useState(null);
  const [erro, setErro] = useState(null);
  const deviceRef = useRef(null);

  const pedirCodigo = async () => {
    setErro(null);
    setCode(null);
    try {
      const r = await fetch(API_ROUTES.DEVICE.code(), { method: "POST" });
      const j = await r.json();
      deviceRef.current = j.deviceId;
      setCode(j.code);
    } catch {
      setErro("Não consegui gerar o código. Tente de novo em instantes.");
    }
  };

  useEffect(() => {
    pedirCodigo();
  }, []);

  // Fica perguntando se já vincularam. Quando vier o token, salva e entra.
  useEffect(() => {
    if (!code || !deviceRef.current) return undefined;
    const t = setInterval(async () => {
      try {
        const r = await fetch(API_ROUTES.DEVICE.poll(deviceRef.current));
        const j = await r.json();
        if (j.status === "vinculado" && j.token) {
          clearInterval(t);
          localStorage.setItem("token", j.token);
          navigate("/");
        } else if (j.status === "expirado") {
          clearInterval(t);
          pedirCodigo(); // pede um código novo automaticamente
        }
      } catch {
        /* rede instável — tenta de novo no próximo tick */
      }
    }, 3000);
    return () => clearInterval(t);
  }, [code, navigate]);

  const site = (typeof window !== "undefined" ? window.location.host : "reinoplay.app").replace(/^www\./, "");
  // Link que o QR carrega: abre /tv no celular JÁ com o código preenchido — a pessoa só confirma
  // (e, se já estiver logada no navegador, a TV libera sozinha). O código fica de reserva.
  const origin = typeof window !== "undefined" ? window.location.origin : "https://reinoplay.app";
  const link = code ? `${origin}/tv?code=${code}` : null;

  return (
    <div style={wrap}>
      <div style={{ fontSize: 15, letterSpacing: 2, color: "#e50914", fontWeight: 700, marginBottom: 8 }}>
        REINOPLAY · ENTRAR NA TV
      </div>
      <h1 style={{ fontSize: 34, margin: "0 0 10px", fontWeight: 800 }}>
        Entre na TV em segundos
      </h1>
      <p style={{ fontSize: 20, color: "#bbb", margin: "0 0 30px", lineHeight: 1.5, maxWidth: 760 }}>
        Aponte a câmera do celular para o QR abaixo — ou acesse{" "}
        <strong style={{ color: "#fff" }}>{site}/tv</strong> (já logado) e digite o código.
        Assim que confirmar, a TV entra sozinha.
      </p>

      {erro ? (
        <div style={{ color: "#ff8c00", fontSize: 20 }}>{erro}</div>
      ) : code ? (
        <div style={pareRow}>
          {/* QR — caminho principal: aponta a câmera e cai no /tv já preenchido */}
          <div style={qrCard}>
            <QRCodeSVG value={link} size={220} level="M" bgColor="#ffffff" fgColor="#0e0e10" />
          </div>
          <div style={{ color: "#666", fontSize: 22, fontWeight: 700 }}>ou</div>
          {/* Código — reserva pra quem preferir digitar */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
            <div style={codeBox}>
              {code.split("").map((ch, i) => (
                <span key={i} style={ch === " " ? {} : codeChar}>{ch}</span>
              ))}
            </div>
            <div style={{ fontSize: 15, color: "#888" }}>
              digite em <strong style={{ color: "#bbb" }}>{site}/tv</strong>
            </div>
          </div>
        </div>
      ) : (
        <div style={{ fontSize: 20, color: "#888" }}>Gerando código…</div>
      )}

      <p style={{ fontSize: 15, color: "#666", marginTop: 34 }}>
        Aguardando você confirmar no celular… (o código expira em 10 minutos)
      </p>
    </div>
  );
}

const wrap = {
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  color: "#fff",
  background: "#0e0e10",
  padding: "6vh 4vw",
};
const pareRow = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 30,
  flexWrap: "wrap",
};
const qrCard = {
  background: "#fff",
  padding: 18,
  borderRadius: 18,
  lineHeight: 0,
  boxShadow: "0 8px 30px rgba(0,0,0,0.4)",
};
const codeBox = { display: "flex", gap: 14 };
const codeChar = {
  fontSize: 64,
  fontWeight: 800,
  letterSpacing: 2,
  background: "#1e1e24",
  border: "2px solid #333",
  borderRadius: 14,
  padding: "14px 22px",
  minWidth: 44,
  color: "#fff",
};
